<template>
  <div style="width: 100%;" v-loading.body="loading" element-loading-text="Loading...">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          VENDOR LISTING
        </el-row>
      </el-col>
      <el-col class="small">
          <a @click="showJson = ! showJson">.&nbsp;</a>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-button plain v-if="disableReportRun">
            <b-spinner class="mr-2" small /> Please Wait
          </el-button>
          <el-button plain @click="generateReport" :disabled="disableReportRun" v-else>
            Run report
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Report Options
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Report Output
      </el-col>
      <el-col :span="4">
        <el-select v-model="reportOptions.format">
          <el-option
            v-for="opt in reportOutputFormats"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="clear"></div>
    <el-row type="flex" align="middle" justify="end" class="section">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Vendor Selection
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-radio-group v-model="reportOptions.vendorQuickPick" @change="updateVendors" :disabled="loading || disableReportRun">
          <el-radio-button label="custom">Custom</el-radio-button>
          <el-radio-button label="all">All</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row v-show="reportOptions.vendorQuickPick==='custom'" type="flex" align="top" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-transfer
          ref="vendorTransfer"
          v-model="selectedCodes.vendor_id"
          :data="vendors"
          :titles="[ 'Unselected Vendors', 'Selected Vendors' ]"
          :props="{ key: 'id', label: 'display_name' }"
          filterable
          filter-placeholder="Search Vendors"
        >
        </el-transfer>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <p><sup>*</sup> Required</p>
      </el-col>
      <el-button plain v-if="disableReportRun">
        <b-spinner class="mr-2" small /> Please Wait
      </el-button>
      <el-button plain @click="generateReport" :disabled="disableReportRun" v-else>
        Run report
      </el-button>
    </el-row>
    <el-row v-if="showJson">
      <el-col>
        <textarea id="output" style="width: 100%; height: 500px;" v-model="prettyJson"></textarea>
      </el-col>
    </el-row>
    <el-row v-if="showJson">
      <el-col :span="1">
        <el-button plain @click="generateCustomReport" :disabled="disableReportRun">
          Run Customized Report
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { mapGetters } from 'vuex'
  import { notify } from '../../utils/helpers/Notify'
  import { buildInitPromiseIterable } from '../../utils/helpers/BuildPromiseIterable'
  import { sortObjectByProperty } from '../../utils/helpers/ObjectSorting'
  import { capitalizeFirstLetter } from '../../utils/helpers/StringOperations'
  import { reportMixins } from '../../Mixins/Reports'
  import { getHeaders } from '@/utils/api'
  import cityMixin from '@/Mixins/CityMixin'
  import Axios from 'axios'

  export default {
    name: 'VendorListCustom',
    mixins: [ reportMixins, cityMixin ],
    props: {
    },
    data () {
      const { getJasperHost } = this.$store.getters
      return {
        reportOptions: {
          transactionStatuses: [ 'posted', 'closed' ],
          accountQuickPick: 'all',
          type: 'detail',
          dates: 'datesAll',
          vendorQuickPick: 'all',
          sort: 'vendor',
          status: 'all',
          format: 'pdf'
        },

        allCodes: {},
        allVendors: [],
        selectedCodes: {
          vendor_id: [],
          company_id: undefined,
          production_id: undefined
        },
        jasperSettings: {
          reportServer: `${getJasperHost}rest_v2/reports/Revolution/Phoenix/`,
          reportName: 'vendor_listing'
        },

        reportOutputFormats: [
          { value: 'pdf', label: 'PDF' },
          { value: 'csv', label: 'CSV' }
        ],
        sortedVendors: [],     // Sorted data by accounts, transaction ID.  Needed for 90% of reports
        disableReportRun: false, // Disable run report button if false
        prettyJson: undefined,
        showJson: false,
        reportNotif: undefined,
        loading: false
      }
    },

    computed: {
      username () { return this.$store.getters.getUser.username },
      vendors () {
        let vendors = []
        // FYI.  Element does not like the map method for the el-transfer component.  Must use a for loop
        for (const i in this.allVendors) {
          const vendor = this.allVendors[i]
          vendor.display_name = vendor.code + ' - ' + vendor.name
          if (vendor.id && vendor.active) vendors.push(vendor)
        }
        return vendors
      }
    },

    watch: {
    },

    methods: {
      resetComponent () {
        this.prettyJson = undefined
        this.clearStore()
      },
      clearStore () {
        // TODO
      },
      updateReportType (type) {
        this.jasperSettings.reportName = 'vendor_history_' + type
      },
      updateVendors (type) {
        if (!type) return false
        switch (type) {
          case 'none':
            this.disableReportRun = false
            this.selectedCodes.vendor_id = []
            break
          case 'all':
            this.disableReportRun = false
            this.selectedCodes.vendor_id = this.allVendors.map(vendor => vendor.id)
            break
          case 'custom':
            this.disableReportRun = false
            break
          default:
            return undefined
        }
        // The transfer table is one tick behind.  Force update now
        this.$forceUpdate()
        return true
      },
      selectReportFormat ({target}) {
        if (target.checked) {
          this.reportOptions.format = 'csv'
        } else {
          this.reportOptions.format = 'pdf'
        }
      },

      async buildVendorList () {
        let json = {
          report: {
            report_title: 'Vendor Listing',
            report_subtitle: '',
            report_name: 'vendor_listing',
            printed_by: this.username,
            date_run: this.today(),
            company: (this.selectedCodes.company_id) ? (this.allCodes.companies.find(({id}) => id === this.selectedCodes.company_id) || {}).name : this.allCodes.companies[0].name,
            project: (this.selectedCodes.production_id) ? (this.allCodes.productions.find(({id}) => id === this.selectedCodes.production_id) || {}).name : this.allCodes.productions[0].name,
            vendors: this.reportOptions.vendorQuickPick,
            num_items: 0,
            data: []
          }
        }

        // Put finished data here
        for await (let selected of this.selectedCodes.vendor_id) {
          let vendor = this.allVendors.find(ven => ven.id === selected)

          const stateId = (vendor.address_selected || {}).state
          vendor.address1 = (vendor.address_selected || {}).line1
          vendor.address2 = (vendor.address_selected || {}).line2
          vendor.state = stateId ? (this.$store.getters.getStateById(stateId)).code : ''
          vendor.postal = (vendor.address_selected || {}).postal
          vendor.contact_name = (vendor.address_selected || {}).contact_name
          vendor.contact_phone = vendor.phone_cell || vendor.phone_home || ''
          vendor.contact_email = vendor.email || ''
          if (vendor.address_selected && typeof vendor.address_selected.city === 'number') {
            await this.getCityById(vendor.address_selected.city).then(cityName => {
              vendor.city = cityName
              json.report.data.push(vendor)
              json.report.num_items++
            })
          } else {
            vendor.city = (vendor.address_selected || {}).city
            json.report.data.push(vendor)
            json.report.num_items++
          }
        }
        return json
      },

      buildCsvData (sortedVendors) {
        // Available Fields: active, alias_name, alias_type, default_accounts, default_tax_code, display_name, petty_cash_account, petty_cash_custodian, petty_cash_custodian_account, petty_cash_enabled, phone_cell, phone_home, w9
        let detailedColumns = { 'Vendor Number': 'code', 'Vendor Name': 'name', 'Address 1': 'address1', 'Address 2': 'address2', 'City': 'city', 'State': 'state', 'Postal': 'postal', 'Contact Name': 'contact_name', 'Contact Phone': 'contact_phone', 'Contact Email': 'contact_email', 'Tax ID': 'tax_id', 'Tax Name': 'tax_name', 'Work State': 'work_state', 'Entity Type': 'entity_type', 'Default Payment Method': 'default_payment_type', 'Description': 'description', 'Parent': 'parent', 'Payee Name': 'payee_name', 'Account Number': 'account_number' }
        let summaryColumns = { 'Vendor Number': 'code', 'Vendor Name': 'name', 'Address 1': 'address1', 'Address 2': 'address2', 'City': 'city', 'State': 'state', 'Postal': 'postal', 'Contact Name': 'contact_name', 'Contact Phone': 'contact_phone', 'Contact Email': 'contact_email' }
        let columnMap = (this.reportOptions.type === 'summary') ? summaryColumns : detailedColumns

        return new Promise((resolve, reject) => {
          this.disableReportRun = false
          let finalCsv = this.createCsv(sortedVendors, columnMap)
          if (finalCsv) resolve(finalCsv)
          else reject('Could not build CSV.')
        })
      },

      async generateReport () {
        this.loading = true
        this.disableReportRun = true
        const json = await this.buildVendorList()

        if (this.reportOptions.format === 'csv') {
          this.buildCsvData(json.report.data)
            .then((resCsv) => {
              this.loading = false
              this.prettyJson = resCsv
              this.createNotification('Success', 'CSV is Ready. ', 'success', false, true, 'VendorList')
              return true
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        } else {
          this.prettyJson = JSON.stringify(json, null, 2)
          this.getJsonUrl(json)
            .then(resJsonUrl => {
              // PDF version of the report
              let report = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.pdf?net.sf.jasperreports.json.source=' + resJsonUrl
              // HTML version of the report
              let preview = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.html?net.sf.jasperreports.json.source=' + resJsonUrl
              return this.getReportUrl(report)
            })
            .then(reportUrl => {
              this.loading = false
              this.createNotification('Success', 'Report is Ready. ', 'success', reportUrl)
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        }
      }
    },

    beforeCreate () {
    },

    created () {
      // Load data to be used for validation
      this.loading = true
      this.disableReportRun = true
      this.getCompanyCodes()
        .then(() => {
          if (!this.allCodes.companies) {
            this.allCodes.companies = this.$store.getters.getAllCompanies
          }
          if (!this.allCodes.productions) {
            this.allCodes.productions = this.$store.getters.getAllProductions
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })

      this.getAllVendors()
        .then(response => {
          if (!response || !Array.isArray(response)) return false

          this.allVendors = sortObjectByProperty(response, 'code')
          this.disableReportRun = false
        })
        .catch(error => {
          this.disableReportRun = false
          console.log(error)
        })
    },

    mounted () {
    },

    beforeDestroy () {
      this.resetComponent()
    }
  }
  
</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>



// WEBPACK FOOTER //
// src/components/Reports/VendorListCustom.vue